import { jsxs as c, jsx as l } from "react/jsx-runtime";
const a = (i) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...i,
    children: [
      /* @__PURE__ */ l("g", { fill: "currentcolor", clipPath: "url(#notifications-filled_svg__a)", children: /* @__PURE__ */ l("path", { d: "M14.235 19c.865 0 1.322 1.024.745 1.668A4 4 0 0 1 12 22a4 4 0 0 1-2.98-1.332c-.552-.616-.158-1.579.634-1.661l.11-.006zM12 2c1.358 0 2.506.903 2.875 2.141l.046.171.008.043a8.01 8.01 0 0 1 4.024 6.069l.028.287L19 11v2.931l.02.136a3 3 0 0 0 1.144 1.847l.167.117.162.099c.86.487.56 1.766-.377 1.864L20 18H4c-1.028 0-1.387-1.364-.493-1.87a3 3 0 0 0 1.472-2.063L5 13.924v-2.97A8 8 0 0 1 8.823 4.5l.248-.146.01-.043a3 3 0 0 1 2.562-2.29l.182-.017z" }) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "notifications-filled_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  a as default
};
